import { z } from "zod";
import { ReportExecutionHistoryParameterDtoSchema } from "./ReportExecutionHistoryParameterDto";
import { ReportRunPeriodsTypeEnum, ReportRunPeriodsTypeEnumSchema } from "@/Enums/ReportRunPeriodsType";

export const ScheduleReportInputSchema = z.object({
    reportId: z.number(),
    sendNotification: z.boolean(),
    reportUrl: z.string().nullable(),
    parameters: z.array(ReportExecutionHistoryParameterDtoSchema),
    isRunningPeriodically: z.boolean().default(false),
    periodicity: ReportRunPeriodsTypeEnumSchema.default(ReportRunPeriodsTypeEnum.RUN_DAILY),
});

export type ScheduleReportInput = z.infer<typeof ScheduleReportInputSchema>;